<template>
  <div>
    <div v-show="mustShow">
      <w-button
          style="animation-delay: 0.2s;animation-duration: 0.2s"
          color="primary"
          data-test="weetShareButton"
          @click="openPopUp" size="small"
      >
        {{ $t('generic.share') }} {{ numberOwners }}
      </w-button>
      <SharePanel v-if="weet!==undefined" :weet="weet" :active.sync="popUpActive" @close="onClosePopup"/>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import WButton from '@/components/wrapper/w-button.vue';
import {Weet} from '@/store/weet/weetModel';
import WModal from '@/components/wrapper/w-modal.vue';
import PopUpTitle from '@/components/title/PopUpTitle.vue';
import WError from '@/components/wrapper/w-error.vue';
import UserAvatar from '@/components/user/UserAvatar.vue';
import WInput from '@/components/wrapper/w-input.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import SharePanel from '@/components/share/SharePanel.vue';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import {hideGlobalTour, restoreGlobalTour} from '@/utils/tour';

@Component({
  components: {SharePanel, WToolTip, WInput, UserAvatar, WError, PopUpTitle, WModal, WButton},
})
export default class ShareButton extends Vue {
  @Prop()
  private weet!: Weet;
  private mustShow: boolean = false;
  private popUpActive: boolean = false;


  public mounted() {
    this.mustShow = true;
  }

  public openPopUp() {
    hideGlobalTour();
    setActionEvent(ActionEvent.player_button_share);
    this.popUpActive = true;
  }

  public onClosePopup() {
    restoreGlobalTour();
  }

  get numberOwners(): string {
    if (this.weet === undefined || this.weet.owners.length <= 1) {
      return '';
    } else {
      return '(' + this.weet.owners.length + ')';
    }
  }

}
</script>

<style scoped lang="scss">
.contentModal {
  background: #FFF;
  max-width: 600px;
  padding: 16px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 64px;
  border-radius: 8px;
  margin: auto;
  position: relative;

  .shareLink {
    display: flex;
    font-size: 12px;
    font-weight: 400;
    align-items: center;

    .copyLinkButton {
      margin-left: 8px;
    }
  }

  .emailInput {
    width: 100%;
  }

  .authorisationInput {
    margin-top: 16px;
    display: flex;
    animation-duration: 0.2s;

    .authorisationSelect {
      flex: 1;
      margin-right: 32px;
      min-width: 400px;
    }

    .inviteButtonBlock {
      text-align: right;
      width: 100%;
    }
  }

  .listOfUser {
    margin-top: 16px;
    text-align: left;

    .userElement {
      margin-top: 8px;
      align-items: center;
      display: flex;

      .userDescription {
        font-size: 14px;
        font-weight: 400;
        padding-left: 16px;
        padding-right: 16px;
      }

      .authSelect {
        font-size: 14px;
        font-weight: 400;
      }

      .action {
        text-align: right;
        flex: 1;
      }
    }

  }

  .viewNext {
    text-align: left;
    margin-top: 16px;
  }

  .bottomLine {
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 16px;
    left: 0;
  }
}
</style>
